import React from "react";
import { Row, Col } from "react-bootstrap";
import OperatorFilter from "../Operator/OperatorFilter";
import operatorData from "../Operator/OperatorData";
import OperatorCard from "../Operator/OperatorCard";

const OperatorTab = () => {
  return (
    <>
      <section className="">
        
          <Row className="my-lg-4 my-2 pt-3 justify-content-center margin_bottomfooter mb-5">
            <Col lg={12} xxl={11}>
              <div className="" id="grid-data" data-pjax-container>
                <form action="" id="safarioperatorsearch" method="get" data-pjax>
                <Row>
                  <Col xxl={2} xl={3} lg={4} className="mb-4 ">
                    <div className="" id="targetDiv">
                      <OperatorFilter />
                    </div>
                  </Col>
                  <Col xxl={10} xl={9} lg={8} className="position-relative">
                    <div className="topfilter d-lg-flex d-none justify-content-between  w-100 mb-2">
                      <div className="left_text">
                        <p className="mb-0">
                          There are currently <strong>5</strong> safari tour
                          operator
                        </p>
                      </div>
                      <div className="right-select d-flex gap-2 align-items-center pe-xl-2">
                        <div className="input_check pb-0 mb-3">
                          <div className="form-group field-sharesafarisearch-custom_sort_by">
                            <select
                              id="sharesafarisearch-custom_sort_by"
                              className="form-control custom_sort_by_input"
                              name="ShareSafariSearch[custom_sort_by]"
                            >
                              <option selected="" value="">
                                Sort by : Rating High to Low
                              </option>
                              <option value="1" className="">
                                Rating High to Low
                              </option>
                              <option value="2" className="">
                                Rating Low to High
                              </option>
                              <option value="3" className="">
                                Name A-Z
                              </option>
                              <option value="4" className="">
                                Name Z-A
                              </option>
                            </select>
                            <div className="help-block"></div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="top_mobilefilter mb-3 d-flex gap-2 d-lg-none justify-content-between align-items-center w-100">
                      <div className="left_text">
                        <p className="mb-0">
                          There are currently <strong>5</strong> safari tour
                          operator
                        </p>
                      </div>
                      <div
                        className="right-select mobile_serach mb-md-0 "
                        id="mobileSearchDiv"
                      >
                        <div className="input_check pb-0">
                          <div className="filter_searchbox">
                            <span>
                              Filter
                              <i className="fa-solid fa-chevron-down"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <Col xs={12}>
                      <div className="tag-container"></div>
                    </Col>

                   <div className="gridview mt-2">
                    <Row className="row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 row-cols-xxl-4 gx-xxl-4">
                    {operatorData.map((operators) => (
                      <Col xxl={3} xl={4} lg={6} md={4} sm={6} className="mb-3" key={operators.id}>
                        <OperatorCard operators={operators} />
                      </Col>
                    ))}
                    </Row>
                   </div>
                  </Col>
                </Row>
                </form>
              </div>
            </Col>
          </Row>
  
      </section>
    </>
  );
};

export default OperatorTab;

